import React, { useEffect, useState, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { handleScrollToSection as ScrollToSection } from "@/utils";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { getPartnerUrl } from "@/redux/DiagnosticReducer";
import MainTemplate from "@/components/Templates/MainTemplate";

import HealthConditions from "./HealthConditions";
import HeroSection from "./HeroSection";
import {
  mapHeroSectionData,
  mapHealthConditionData,
  mapPackageData,
  mapPartnerData,
  mapFormData,
} from "./mapDiagnosticData";
import SelectPackage from "./PackageSelector";
import PartnerForm from "./PartnerForm";
import PartnerSelector from "./PartnerSelector";

function DiagnosticPage({ slug, urlParams, ref_code }) {
  const { width } = useWindowDimensions();
  const dispatch = useAppDispatch();
  const diagnosticPageData = useAppSelector((state) => state.diagnosticPage);

  const {
    data,
    error,
    isPartnerUrlLoading,
    partnerUrlError,
    partnerUrlSuccess,
    partnerUrlData,
  } = diagnosticPageData;
  const healthConditionData = mapHealthConditionData(data);
  const testBookFormRef = useRef(null);

  const [activeCondition, setActiveCondition] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(0);
  const [activePackage, setActivePackage] = useState([]);
  const [activePartnerList, setActivePartnerList] = useState([]);
  const [inlineForm, setInlineForm] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(0);

  useEffect(() => {
    const actCondition = healthConditionData?.conditions?.[0];
    setActiveCondition({
      data: actCondition,
      id: 0,
    });
    setActivePackage({
      data: actCondition?.packages,
      id: 0,
    });
    setActivePartnerList(actCondition?.packages?.[0]?.partners);
  }, [data]);

  useEffect(() => {
    if (!isPartnerUrlLoading && partnerUrlSuccess) {
      if (partnerUrlData?.type === "external") {
        setInlineForm(false);
        window.open(partnerUrlData?.route);
      } else if (partnerUrlData?.type === "inlineForm") {
        setInlineForm(true);
      } else {
        setInlineForm(false);
        window.location.href = partnerUrlData?.route;
      }
    }
  }, [partnerUrlData]);
  useEffect(() => {
    if (inlineForm === true) {
      ScrollToSection({ refElement: testBookFormRef, position: "center" });
    }
  }, [inlineForm]);

  const handleCTAClick = (data) => {
    setSelectedPartner(data);
    let trackSlug = slug + "/track";
    dispatch(
      getPartnerUrl({ slug: trackSlug, ref_code, mapping_slug: data?.slug })
    );
  };

  const onHealthConditionChange = (condition, index) => {
    setActiveCondition({ data: condition, id: index });
    setSelectedPackage(0);
    setActivePackage({
      data: condition?.packages,
      id: 0,
    });
    setInlineForm(false);
    setActivePartnerList(condition?.packages[0]?.partners);
  };

  const onPackageChange = (index) => {
    setSelectedPackage(index);
    setInlineForm(false);
    setActivePartnerList(activeCondition?.data?.packages[index]?.partners);
  };

  return (
    <MainTemplate hideHeader error={error}>
      <HeroSection data={mapHeroSectionData(data)} width={width} />
      {healthConditionData?.conditions?.length > 0 && (
        <HealthConditions
          data={healthConditionData}
          activeCondition={activeCondition}
          width={width}
          onHealthConditionChange={onHealthConditionChange}
        />
      )}
      {activePackage?.data?.length > 0 && (
        <SelectPackage
          data={mapPackageData(data)}
          activePackage={activePackage}
          selectedPackage={selectedPackage}
          width={width}
          onPackageChange={onPackageChange}
        />
      )}
      {activePartnerList?.length > 0 && (
        <PartnerSelector
          data={mapPartnerData(data)}
          width={width}
          partnerList={activePartnerList}
          handleCTAClick={handleCTAClick}
          isLoading={isPartnerUrlLoading}
          inlineForm={inlineForm}
        />
      )}
      {inlineForm && (
        <PartnerForm
          ref={testBookFormRef}
          width={width}
          selectedPackage={activePackage?.data?.[selectedPackage]}
          setShowModal={setInlineForm}
          urlParams={urlParams}
          {...mapFormData(partnerUrlData, selectedPartner)}
        />
      )}
    </MainTemplate>
  );
}

export default DiagnosticPage;
